import style from "./Sidebar.module.css";
import SidebarItem from "../sidebarItem/sidebarItem";
import { FaUser, FaUsers, FaCogs, FaChalkboardTeacher, FaUserGraduate } from "react-icons/fa";
import { FaClipboardUser } from "react-icons/fa6";
import clsx from "clsx";
import { MdLeaderboard } from "react-icons/md";
import { IoIosNotifications } from "react-icons/io";
import { MdContactSupport } from "react-icons/md";
import { useEffect, useRef } from "react";
import { useIsMobile } from "../useIsMobile/UseIsMobile";

function Sidebar({ children, menuHamburguerAberto, setMenuHamburguerAberto }) {
  const isMobile = useIsMobile();
  const sidebarRef = useRef(null);

  // Fecha sidebar ao clicar fora no mobile
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        isMobile &&
        menuHamburguerAberto &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        setMenuHamburguerAberto(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuHamburguerAberto, isMobile]);

  return (
    <div className={style.container_total}>
      {isMobile && menuHamburguerAberto && <div className={style.overlay}></div>}

      <div
        ref={sidebarRef}
        className={clsx(style.sidebar_conteudo, {
          [style.sidebar_hidden]: !menuHamburguerAberto,
        })}
      >
        <div className={style.sidebar_corpo}>
          <SidebarItem texto="Usuários" link="/" logo={<FaUser />} />
          <SidebarItem texto="Alunos" link="/backoffice/alunos" logo={<FaUserGraduate />} />
          <SidebarItem texto="Monitores" link="/backoffice/monitores" logo={<FaChalkboardTeacher />} />
          <SidebarItem texto="Coordenadores" link="/backoffice/Coordenadores" logo={<FaClipboardUser />} />
          <SidebarItem texto="Grupo de Usuários" link="/backoffice/grupoDeUsuario" logo={<FaUsers />} />
          <SidebarItem texto="Leads" link="/backoffice/leads" logo={<MdLeaderboard />} />
          <SidebarItem texto="Sistemas" link="/backoffice/sistema" logo={<FaCogs />} />
          <SidebarItem texto="Avisos" link="/backoffice/avisos" logo={<IoIosNotifications />} />
          <SidebarItem texto="Suportes" link="/backoffice/suportes" logo={<MdContactSupport />} />
        </div>
      </div>

      <div
        className={clsx(style.pagina_conteudo, {
          [style.closed]: !menuHamburguerAberto && !isMobile,
        })}
      >
        {children}
      </div>
    </div>
  );
}

export default Sidebar;
